import { Injectable } from '@angular/core';
import { serverPort, base_url } from "../../../server/src/config/config";
import { CashBooking } from "../models/CashBooking";
import { Http, Response } from "@angular/http";
import 'rxjs/add/operator/map';

@Injectable()
export class CashBookingService {

  constructor(private http: Http) {
  }

  create(cash_booking: CashBooking) {
    return this.http.post(`${base_url}/v1/bookings`, cash_booking).map((response: Response) => response.json());
  }

  list() {
    return this.http.get(`${base_url}/v1/bookings`).map((response: Response) => response.json());
  }

  getById(_id) {
    return this.http.get(`${base_url}/v1/bookings?_id=${_id}`).map((response: Response) => response.json());
  }

  putById(_id, cash_booking: CashBooking) {
    return this.http.put(`${base_url}/v1/bookings/${_id}`, cash_booking).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/cash-booking.service.ts